import { render, staticRenderFns } from "./Drivers.view.vue?vue&type=template&id=58638329&scoped=true"
import script from "./Drivers.view.vue?vue&type=script&lang=ts"
export * from "./Drivers.view.vue?vue&type=script&lang=ts"
import style0 from "./Drivers.view.vue?vue&type=style&index=0&id=58638329&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58638329",
  null
  
)

export default component.exports